import React, { useState } from 'react';

import T from 'Utilities/texts';

import { Content } from 'LegacySBCRA/Content/Content';

import { useBreakpoint } from '../../../../components/misc/Breakpoints/Breakpoints';
import { ReviewsList } from '../../../../components/reviews/ReviewsList/ReviewsList';

import styles from './Reviews.scss';

const Reviews = () => {
  const [failedLoad, setFailedLoad] = useState(false);
  const breakpoints = useBreakpoint();

  return (
    <>
      <Content
        className={styles.view}
        element="section"
        wrapper={{
          className: styles.wrapper,
        }}
      >
        <h1>{T.translate('customerReviewsView.title')}</h1>
        <p>{T.translate('customerReviewsView.intro', { br: breakpoints?.minWidth?.breakpointTabletMobile ? <br /> : '' })}</p>
      </Content>
      <section className={styles.reviews}>
        <ReviewsList failedLoad={failedLoad} setFailedLoad={setFailedLoad} />
      </section>
    </>
  );
};

export default Reviews;
